import { gql } from '@apollo/client';

/**
 * Query to fetch user-owned applications with pagination and data lead management support
 */
export const UserOwnedAppsQuery = gql`
  query UserOwnedApps(
    $login: String!
    $filter: ResourceCatalogUserApplicationFilter
    $pagination: PaginationInput
    $sortBy: ResourceCatalogApplicationSortByInput
  ) {
    identity {
      user(login: $login) {
        login
        email
        resources {
          applicationsPaged(
            filter: $filter
            pagination: $pagination
            sortBy: $sortBy
          ) {
            applications {
              appGroup
              applicationId
              description
              informationClassificationPolicy {
                name
              }
              functionalAreaConnection {
                dataBusinessOwner {
                  login
                }
                name
              }
              name
              owner {
                displayName
              }
              roles {
                displayName
              }
              status
              updatedAt
              corporateEntity
              serviceDomain
              systemType
              aiUseCaseIds
            }
            totalCount
          }
        }
      }
    }
  }
`;
